var path = 'scripts/views/components/pagination-popover.html';
var html = "<span class=\"pagination-popover\">\n    <span id=\"#pagination-popover-text\">{{ \"pagination.TransactionsPerPage\" | translate }}: </span>\n    <input type=\"text\"\n           size=\"5\"\n           class=\"mlm pagination-input\"\n           ng-model=\"$ctrl.pageSize\" >\n    <button class=\"btn btn-sm btn-default mlm pagination-button\"\n            ng-click=\"$ctrl.setPageSize()\">{{ \"pagination.Repaginate\" | translate }}</button>\n</span>\n\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/pagination-popover.html
// module id = 328
// module chunks = 0